import React from 'react';
import styled from 'styled-components';
import { Row } from '../../styled';
import Button from 'src/components/form/Button';
import { Link } from 'react-router-dom';
import { DangerTooltip } from './DangerTooltip';

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

export const AddIncidents = () => {
  return (
    <Row>
      <Div>
        <DangerTooltip tooltipHtml="This assessment does not <br/>have any linked incidents." />
      </Div>

      <Link to={`/incidents`}>
        <Button primary>+ ADD INCIDENTS</Button>
      </Link>
    </Row>
  );
};
